// extracted by mini-css-extract-plugin
export var orderSummary = "_rl-0";
export var showMoreLessButton = "_rl-1";